import ReactDOM from 'react-dom/client';
import './shared/style/index.css';
import App from './app/App';
import React from 'react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const strictMode = false

root.render(
  strictMode ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (<App />)
);
